'use client';

import { useEffect, useState } from 'react';

import { css } from '@/styled-system/css';

import { onSlotEmpty } from '@/src/lib/ads/gpt';

// GPT's 805px creative container would otherwise widen the cell's 1fr column.
const adSlotItem = css({
  display: 'flex',
  minWidth: 0,
});

const adSlotSurface = css({
  minWidth: 0,
  width: '100%',
  // eslint-disable-next-line hotpads/no-magic-numbers -- legacy's SRP ad card height (AdvertisementWrapper/styles.tsx)
  minHeight: '360px',
  // The slot requests a `fluid` size, which GPT measures from the creative's own
  // content. Stretching the iframe into a fixed box instead — what this did
  // before — crops taller creatives and squashes the 805x115 banner.
  '& iframe': {
    // The creative owns its bottom border, so only clip the host-owned top corners.
    clipPath: 'inset(0 round token(radii.md) token(radii.md) 0 0)',
    maxWidth: '100%',
  },
});

type Props = {
  id: string;
};

export function SrpAdSlot({ id }: Props) {
  const [isUnfilled, setIsUnfilled] = useState(false);

  // GPT's `collapseEmptyDivs` only hides its own div, which would leave this
  // grid cell as a hole between listing cards.
  useEffect(() => onSlotEmpty(id, () => setIsUnfilled(true)), [id]);

  if (isUnfilled) return null;

  return (
    <li className={adSlotItem}>
      <div id={id} className={adSlotSurface} />
    </li>
  );
}
